/*
 * Headings light up word by word as they are scrolled through.
 *
 * Home page only. Each heading's words start in a pale tint of the heading
 * colour and turn solid as the heading travels up the viewport, so the line
 * reads as it arrives. Nothing here moves the text: only colour changes, so a
 * heading never reflows and the words stay selectable and readable to a
 * screen reader.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  var SELECTOR = '.sec-subtitle, .stat-band__heading';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wrapWords(el) {
    if (el.dataset.hrReady) return;
    el.dataset.hrReady = 'true';

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim()) nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var frag = document.createDocumentFragment();
      // Keeping the separators means the spacing is exactly what it was.
      textNode.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (!part.trim()) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'hr-word';
        span.textContent = part;
        frag.appendChild(span);
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });

    el.classList.add('hr-ready');
  }

  var items = [];

  function collect() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (el) {
      if (items.some(function (item) { return item.el === el; })) return;
      wrapWords(el);
      var words = el.querySelectorAll('.hr-word');
      if (!words.length) return;
      items.push({ el: el, words: words, lit: -1 });
    });
  }

  function paint(item, count) {
    if (count === item.lit) return;
    item.lit = count;
    for (var i = 0; i < item.words.length; i++) {
      item.words[i].classList.toggle('is-lit', i < count);
    }
  }

  function update() {
    var vh = window.innerHeight;
    items.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;

      // The heading is fully lit by the time it reaches the middle of the
      // screen, and starts lighting as it comes in from the bottom.
      var start = vh * 0.92;
      var end = vh * 0.45;
      var progress = (start - rect.top) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      paint(item, Math.round(progress * item.words.length));
    });
  }

  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  function start() {
    collect();
    if (!items.length) return;

    if (reduceMotion) {
      items.forEach(function (item) { paint(item, item.words.length); });
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The theme editor re-renders sections; pick up whatever it adds.
  document.addEventListener('shopify:section:load', function () {
    collect();
    update();
  });
})();
